import { getQueryUpdatedQueryString } from "./NavigationHelpers";
import { getRelativePath } from "./GetRelativePath";

export const getProductFeedbackRoute = () => {
  const cannySSOUrl = getRelativePath("sso/canny", "platform");
  const updatedParam = getQueryUpdatedQueryString({
    url: cannySSOUrl,
    params: {
      redirect: "https://roadmap.toddleapp.com/planning",
      companyID: "6916b8a06ad221ef4ed218a8",
    },
  });

  const redirectUrl = `${cannySSOUrl}?${updatedParam}`;
  return redirectUrl;
};

export const getProductRoadmapRoute = () => {
  const cannySSOUrl = getRelativePath("sso/canny", "platform");
  const updatedParam = getQueryUpdatedQueryString({
    url: cannySSOUrl,
    params: {
      redirect: "https://roadmap.toddleapp.com",
      companyID: "6916b8a06ad221ef4ed218a8",
    },
  });

  const redirectUrl = `${cannySSOUrl}?${updatedParam}`;
  return redirectUrl;
};
